module.exports = __webpack_public_path__ + "static/media/Step 3-Scale_and_Measure.fba73642.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/tutorial-images/Step 3-Scale_and_Measure.gif
// module id = 3044
// module chunks = 0